export default "__VITE_ASSET__DV3L3EOe__"